import { Modal } from "antd"

const tint = (id) => (id % 4) + 1

// antd Modal provides the shell + behaviour (Esc, scroll-lock, focus-trap,
// animations); the cozy two-pane content and styling are ours.
const BookModal = ({ book, onClose }) => {
  const csrf = document.querySelector('meta[name="csrf-token"]')?.content

  return (
    <Modal
      open={Boolean(book)}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={900}
      className="book-modal"
      styles={{
        content: { padding: 0, overflow: "hidden", borderRadius: 22, background: "var(--paper)" },
        body: { padding: 0 },
        mask: { background: "rgba(60, 44, 30, 0.34)", backdropFilter: "blur(6px) saturate(108%)" },
      }}
    >
      {book && (
        <div className="modal__sheet">
          <div className="modal__visual">
            {book.cover_url ? (
              <img className="modal__cover" src={book.cover_url} alt={book.title} />
            ) : (
              <span className={`book__cover--blank tint-${tint(book.id)}`}>
                <span className="blank-title">{book.title}</span>
                <span className="blank-author">{book.author}</span>
              </span>
            )}
          </div>

          <div className="modal__body">
            <button type="button" className="modal__close" onClick={onClose} aria-label="Закрити">
              ×
            </button>

            <h2 className="modal__title">{book.title}</h2>
            <p className="modal__author">— {book.author}</p>
            {book.genre && <span className="book__genre">{book.genre}</span>}

            <div className="modal__divider" />

            <dl className="modal__meta">
              <div>
                <dt>Додано на полицю</dt>
                <dd>{book.added_on}</dd>
              </div>
            </dl>

            <div className="modal__actions">
              <a className="btn" href={`/books/${book.id}/edit`}>
                Редагувати
              </a>
              <form
                action={`/books/${book.id}`}
                method="post"
                onSubmit={(event) => !confirm("Прибрати цю книжку з полиці?") && event.preventDefault()}
              >
                <input type="hidden" name="_method" value="delete" />
                <input type="hidden" name="authenticity_token" value={csrf} />
                <button type="submit" className="btn btn-ghost">
                  Видалити
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </Modal>
  )
}

export default BookModal
